export const URLAPISUBIDA = 'https://nebosystem.com/recursos/subirimg.php'

export const URLAPISUBIDAVIDEO = 'https://nebosystem.com/recursos/subirvideo.php'
export const URLCARPETADESTINO = 'https://nebosystem.com/recursos/'

export const URLAPISUBIDAPDF = 'https://nebosystem.com/recursos/subirpdf.php'

export const URLCARPETADESTINOPDF = 'https://nebosystem.com/recursos/'